import React from 'react';
import { Box, Typography } from '@mui/material';

function DualClock() {
  const [time, setTime] = React.useState(new Date());

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatLocalTime = (date: Date) => {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const day = dayNames[date.getDay()];
    const timeStr = date.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
    return `${day} ${timeStr}`;
  };

  const formatUTCTime = (date: Date) => {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const day = dayNames[date.getUTCDay()];
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${day} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mr: 2 }}>
      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="caption" sx={{ display: 'block', lineHeight: 1.2, color: 'text.secondary' }}>
          Local
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 500 }}>
          {formatLocalTime(time)}
        </Typography>
      </Box>
      <Box sx={{ textAlign: 'right' }}>
        <Typography variant="caption" sx={{ display: 'block', lineHeight: 1.2, color: 'text.secondary' }}>
          UTC
        </Typography>
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 500 }}>
          {formatUTCTime(time)}
        </Typography>
      </Box>
    </Box>
  );
}

export default DualClock;
